import store from '../../../../store'
import _station from '../../../../../../../_station'
import('./select_component.css')

export default function SelectComponent(opts = {}){
    let container = opts.container
    let elements = {}
    let chart_name = opts.chart_name
    BaseConstructor.call(this)
    
    let context = this

    this.generate = type =>{
        if(type == 'station_flu'){
            generateFlu()
        }
    }

    function generateFlu(){
        //label
        elements.label = context.createElement('label', '', 'Postos Fluviométricos')

        //select
        elements.select = context.createElement('select', 'w-100')
        elements.select.style.width = "100%"

        //adicionando label e select ao container
        $(container).append(elements.label, elements.select)

        //inicializando select2
        $(elements.select).select2({
            multiple:true,
            ajax: {
              delay: 250,
              url: 'api/v1/station_prefixes/simplify',
              dataType: 'json',
              data: function (params) {
                var query = {
                  start: 0,
                  limit: 10,
                  station_type_ids: [1],
                  search: params.term
                }
                return query;
              },
              processResults: function (response){
                return {
                    results: response.stations.map(x=>({id: x.id, text: x.prefix+ ' - ' + x.station.name}))
                }
              }
              // Additional AJAX parameters go here; see the end of this chapter for the full code of this example
            }
        }, {passive:false});

        //evento de select/unselect
        $(elements.select).on('select2:select select2:unselect', function() {
            let station_prefixes_ids = $(elements.select).select2('data').map(x=>x.id) || []
            store.setChartNestedProp(chart_name, 'stations_list.flu.ids', station_prefixes_ids)
        });

        let select_ones = store.getChartNestedProp(chart_name, 'stations_list.flu.ids') || []
        if(select_ones.length > 0){
          let stations = _station.getStationById(select_ones.map(Number))
          stations.map(x=>{
            var newOption = new Option(`${x.prefix} - ${x.station.name}`, x.id, true, true);
            $(elements.select).append(newOption)
          })

          $(elements.select).trigger('change')
        }
    }

    

}

SelectComponent.prototype = Object.create(BaseConstructor.prototype)